<template>
  <div class="system-builder__view-system--section">
    <div class="system-builder__main-container">

      <div class="system-builder__main-container--header">
        <h2>Get a Quote from Your Local Dealer!</h2>
      </div>

      <div class="system-builder__view-system--main-container">
        <div class="system-builder__view-system--complete-system-container">
          <div class="system-builder__view-system--system-container">
            <div class="system-builder__view-system--edit-nav">
              <span>Your System</span>
              <a @click="printSystem">PRINT</a>
            </div>

            <div class="system-builder__view-system--system-complete">
              <div class="system-builder__view-system--system-image" v-if="sharedState.selectedSystem.images">
                <img :src="sharedState.selectedSystem.images.image.url"
                     :alt="sharedState.selectedSystem.images.image.alt">
              </div>

              <div class="system-builder__view-system--system-content">
                <h4>{{systemString}}</h4>
                <ul>
                  <li v-if="sharedState.vehicleObject.vehicleSpecificId !== '' && sharedState.security === false">T-harness: {{sharedState.vehicleObject.vehicleSpecificId}}</li>
                  <li v-else>{{sharedState.selectedSystem.model_number}}</li>
                  <li>{{sharedState.selectedMake}} / {{sharedState.selectedModel}} / {{sharedState.selectedYearValue}}
                  </li>
                  <li>{{compatibilityMessage}}</li>
                </ul>
                <div v-html="sharedState.selectedSystem.description"></div>
              </div>
            </div>
          </div>

          <div class="system-builder__view-system--addon-container">
            <div class="system-builder__view-system--remote-container">
              <div class="system-builder__view-system--edit-nav">
                <span>Your Remote</span>
                <!--<a @click="remoteToggle=true">edit</a>-->
              </div>

              <div class="system-builder__remotes--item">
                <div class="system-builder__remotes--item-image" v-if="sharedState.selectedRemote.images">
                  <img :src="sharedState.selectedRemote.images.image.url"
                       :alt="sharedState.selectedRemote.images.image.alt">
                </div>

                <div class="system-builder__remotes--item-content">
                  <h3>{{sharedState.selectedRemote.post_title}}</h3>
                  <ul>
                    <li v-for="(feature, featureIndex) in sharedState.selectedRemote.remote_features_text"
                        v-html="feature"
                        v-if="featureIndex < 3">
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="system-builder__view-system--upgrades-container" v-if="sharedState.selectedUpgrades !== undefined && sharedState.selectedUpgrades.length > 0">
              <div class="system-builder__view-system--edit-nav">
                <span>Your Upgrades</span>
              </div>

              <div class="system-builder__upgrades--item" v-for="upgrade in sharedState.selectedUpgrades">
                <div class="system-builder__upgrades--item-image">
                  <img :src="upgrade.images.image.url" :alt="upgrade.images.image.alt">
                </div>

                <div class="system-builder__upgrades--item-content">
                  <h4>{{upgrade.post_title}}</h4>
                  <p>{{upgrade.subtitle}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="system-builder__view-system--contact-container">
          <transition name="fade" mode="out-in" v-if="sharedState.formPassedValidation === false">
            <contactInfo @submitContactForm="checkFormValidation"></contactInfo>
          </transition>
          <transition name="fade" mode="out-in" v-else-if="isCanadianPostCode">
            <canadianContact></canadianContact>
          </transition>
          <transition name="fade" mode="out-in" v-else>
            <dealerList></dealerList>
          </transition>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router'
  import remoteItem from '../reusable/RemoteItem.vue'
  import canadianContact from './CanadianContact.vue'
  import contactInfo from './ContactInfo.vue'
  import dealerList from './DealerList.vue'
  import axios from 'axios'
  import $ from 'jquery'

  export default {
    components: {remoteItem, canadianContact, contactInfo, dealerList},
    name: 'viewSystem',
    props: {
      inquiryId: {
        type: String,
        default: ''
      },
      quoteId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        sharedState: store.state,
        formPassedValidation: false,
        isCanadianPostCode: false
      }
    },
    methods: {
      printSystem: function () {
        window.print()
      },
      checkCanadianPostal (postal) {
        var canadaRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i)
        if (canadaRegex.test(postal)) {
          return true
        } else {
          return false
        }
      },
      checkFormValidation: function () {
        var customerZip = this.sharedState.customerDetails.customerZip

        if (this.checkCanadianPostal(customerZip)) {
          store.changeFormValidationState(true)
          this.formPassedValidation = true
          this.isCanadianPostCode = true
        } else {
          store.changeFormValidationState(true)
          this.formPassedValidation = true
        }
      },
      retrieveDealers: function () {
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var googleMapUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + store.state.customerDetails.customerZip + '&key=AIzaSyBOPUa1-e4k7hsf5qVHNlBr-YHtN7UUQgo'
        axios.get(googleMapUrl)
          .then(function (response) {
            var latLon = response.data.results[0].geometry.location
            $.ajax({
              url: ajaxUrl,
              type: 'POST',
              data: {
                action: 'system-builder-get-dealers',
                location: latLon
              },
              cache: false,
              dataType: 'text',
              success: function (response) {
                var jsonObj = JSON.parse(response)
                store.updateDealersState(jsonObj.stores)
                return false
              }
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      submitInquiryData: function () {
        // Save inquiry data to database
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var inquiryDataSavedStatus = this.sharedState.inquiryDataSaved

        if (inquiryDataSavedStatus === false) {
          $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'text',
            timeout: 7000,
            data: {
              action: 'save-inquiry-data',
              data: store.getStoreDataToSave(),
              stateObject: store.getStateObj()
            },
            cache: false,
            success: function (response) {
              var jsonObj = JSON.parse(response)
              store.inquiryDataSaved(jsonObj)
              return false
            }
          })
        }
      }
    },
    mounted: function () {
      if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
        // Toggle main nav off
        store.toggleMainNav()

        // Inquiry ID supplied, check against DB
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          timeout: 7000,
          data: {
            action: 'system-builder-get-inquiry-data',
            inquiryId: this.inquiryId,
            quoteId: this.quoteId
          },
          cache: false,
          success: function (response) {
            var jsonObj = JSON.parse(response)
            store.updateStateWithData(jsonObj)
            return false
          }
        })
      } else {
        // If no inquiry ID supplied, do route validation
        if (store.state.vehicleObject.year === 'Vehicle Year') {
          store.updateCurrentStateRoute('selectVehicle')
          router.push({name: 'selectVehicle'})
          return false
        } else if (!store.state.selectedRemote) {
          store.updateCurrentStateRoute('selectRemote')
          router.push({name: 'selectRemote'})
          return false
        }
      }
    },
    computed: {
      compatibilityMessage: function () {
        // Display message depending on vehicle compatibility
        if (this.sharedState.vehicleObject.compatibleSystem === false) {
          return this.sharedState.customFields.not_compatible_message_title
        } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
          return this.sharedState.customFields.data_compatible_message_title
        } else {
          return this.sharedState.customFields.data_compatible_message_title
        }
      },
      systemString: function () {
        if (this.sharedState.vehicleObject.vehicleSpecificId !== '') {
          return this.sharedState.selectedSystem.post_title
        } else {
          return this.sharedState.systemString
        }
      },
      customerZip: function () {
        return this.sharedState.customerDetails.customerZip
      },
      validZip: function () {
        var isZipValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.sharedState.customerDetails.customerZip)
        return isZipValid
      }
    },
    beforeCreate: function () {
      store.getLocalStorage()
    },
    watch: {
      formPassedValidation: function () {
        // Only run if formPassedValidation is true
        if (this.formPassedValidation) {
          this.retrieveDealers()
          this.submitInquiryData()
        }
      },
      customerZip: function () {
        // Only run if formPassedValidation is true
        if (this.formPassedValidation && this.validZip) {
          this.retrieveDealers()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ViewSystem.vue?6343926e